import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { Box, styled } from '@mui/material';

export const StyledContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  gap: theme.spacing(5),
}));

export const StyledTitle = styled(Text)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const StyledLegendsClip = styled(Flex)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
}));

export const StyledLegendsColorBox = styled(Box)(({ theme }) => ({
  height: theme.spacing(8),
  width: theme.spacing(6),
  borderRadius: theme.spacing(8),
  marginRight: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(6),
  },
}));
